import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _inflight = null;

/**
 * Fetch the public booking config once per page-load.
 *   booking_mode: "rms" | "enquiry"
 *   rms_booking_url: hosted IBE URL when enabled, otherwise ""
 */
export async function getBookingConfig() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${API}/config`)
    .then((r) => {
      _cache = r.data;
      return _cache;
    })
    .catch(() => ({ booking_mode: "enquiry", rms_booking_url: "" }))
    .finally(() => {
      _inflight = null;
    });
  return _inflight;
}

/**
 * Ask the backend to compose a deep-link to the RMS Cloud booking engine
 * with the selected category / dates / guests pre-filled. The exact param
 * names are server-controlled (env-driven), so the backend stays the single
 * source of truth.
 */
export async function getBookingUrl({ category, arrival, departure, adults, children }) {
  try {
    const params = new URLSearchParams();
    if (category) params.set("category", category);
    if (arrival) params.set("arrival", arrival);
    if (departure) params.set("departure", departure);
    if (adults) params.set("adults", adults);
    if (children) params.set("children", children);
    const qs = params.toString();
    const { data } = await axios.get(`${API}/booking/url${qs ? `?${qs}` : ""}`);
    return data?.url || null;
  } catch {
    return null;
  }
}
